import { useCallback, useState } from 'react';

import {
  ActivityBuilderDrawerWrapper,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerActions,
} from 'approot/activity-builder/activity-builder-drawer';
import StimulusSearch from 'approot/shared/stimulus/search/stimulus-search';
import type { StimulusResourceFragment } from '../../../shared/stimulus/stimulus.graphql.generated';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import { COMPONENT_TEMPLATE_IMAGE_ID, IMAGE } from 'global/constants';
import { MenuCategory, MenuData } from './components-menu.constants';

type Props = {
  menuItems: MenuData[];
  goBack: () => void;
};

const ComponentAddStimulusMenu = ({ menuItems, goBack }: Props) => {
  const [selectedStimulus, setSelectedStimulus] = useState<
    StimulusResourceFragment | undefined
  >();

  const handleChooseItem = useCallback(() => {
    const stimulusType = selectedStimulus?.type;

    if (stimulusType === IMAGE) {
      // image template data is not in the Stimulus section so grab it from
      // the image section instead
      const imageCategory = menuItems.find(
        m => m.section === MenuCategory.Image
      );
      const imageTemplate = imageCategory?.items.find(
        i => i.id === COMPONENT_TEMPLATE_IMAGE_ID
      );
      imageTemplate?.onClick(selectedStimulus);
    } else {
      const items =
        menuItems.find(m => m.section === MenuCategory.Stimulus)?.items || [];
      const templateData = items.find(i => i.id === stimulusType);
      templateData?.onClick(selectedStimulus);
    }
  }, [selectedStimulus, menuItems]);

  return (
    <ActivityBuilderDrawerWrapper>
      <ActivityBuilderDrawerHeader
        isBack
        title="Search All Stimulus"
        onClose={goBack}
      />
      <ActivityBuilderDrawerContent>
        <StimulusSearch
          withMediaPreview
          stackFilters
          selectedStimulus={selectedStimulus}
          onStimulusSelected={stimulus => setSelectedStimulus(stimulus)}
        />
      </ActivityBuilderDrawerContent>
      <ActivityBuilderDrawerActions>
        <PrimaryButton
          data-selector="btn-choose-stimulus"
          type="button"
          disabled={!selectedStimulus}
          onClick={handleChooseItem}
        >
          Choose Stimulus
        </PrimaryButton>
      </ActivityBuilderDrawerActions>
    </ActivityBuilderDrawerWrapper>
  );
};

export default ComponentAddStimulusMenu;
